import Request from '../data/request'
import Goal from "../../model2/goal/goal"
import Message from "../../model2/message/message"
import {EntityType} from "../const/item"
import {GoalApiStatus} from "../../model2/goal/collection"

const debug = false
// const debug = "ApiGoal"

export default class ApiGoal {

    static create(goal:Goal) {
        debug && console.log(debug, "create")
        return new Request(this, 'POST', 'goals/create', goal.toJSON())
    }

    static duplicate(goalId:ID, params: {
        newName             : string
        newParentGoalId?    : ID
        copySubGoals        : boolean
        copyProgress        : boolean
        copyUsers           : boolean
    }) {
        debug && console.log(debug, "duplicate")
        return new Request(this, 'POST', 'goals/{0}/duplicate'.f(goalId), params)
    }

    static getAllGoals(goalStatus?: GoalApiStatus) {
        debug && console.log(debug, "getAllGoal")

        const params: any = {
            status      : goalStatus || 'all'
        }

        return new Request(this, 'GET', 'goals', params)
    }

    static getProjectGoals(projectId: ID, goalStatus?: GoalApiStatus) {
        debug && console.log(debug, "getProjectGoals", projectId)

        const params: any = {
            projectId   : projectId,
            status      : goalStatus || 'all'
        }

        return new Request(this, 'GET', 'goals', params)
    }

    static getGoal(goalID: ID) {
        debug && console.log(debug, "getGoal")
        return new Request(this, 'GET', 'goals/{0}'.f(goalID))
    }

    static update(id:ID, params:any) {
        debug && console.log(debug, "update", id, params)
        return new Request(this, 'PUT', 'goals/{0}'.f(id), params)
    }

    static delete(goalID:ID) {
        debug && console.log(debug, "delete")
        return new Request(this, 'DELETE', 'goals/{0}'.f(goalID))
    }

    static getComments(goalID:ID) {
        debug && console.log(debug, "getComments")

        const params = {
            "entityId"  : goalID,
            "entityType": EntityType.GOAL,
        }

        return new Request(this, 'POST', 'comments', params)
    }

    static getComment(messageID:ID) {
        debug && console.log(debug, "getComment")
        return new Request(this, 'GET', 'comments/{0}'.f(messageID))
    }

    static addComment(goalID:ID, message:Message) {
        const messageJSON = message.toJSON()
        debug && console.log(debug, "addComment", goalID, messageJSON)

        const params: any = {
            "parentEntityId"    : goalID,
            "parentEntityType"  : EntityType.GOAL,
            "messageTxt"        : messageJSON.contentText,
            "messageRtf"        : messageJSON.contentRTF,
            "companyId"         : gd.companyId,
        }

        if (messageJSON.attachments) params.attachments = messageJSON.attachments

        return new Request(this, 'POST', 'comments/create', params)
    }

    static editComment(goalID:ID, message:Message) {
        const messageJSON = message.toJSON()
        debug && console.log(debug, "editComment", goalID, messageJSON)

        const params: any = {
            "messageTxt"        : messageJSON.contentText,
            "messageRtf"        : messageJSON.contentRTF,
        }

        if (messageJSON.attachments) params.attachments = messageJSON.attachments

        return new Request(this, 'PUT', 'comments/{0}'.f(message.id), params)
    }

    static deleteComment(goalID:ID, messageID:ID) {
        debug && console.log(debug, "deleteComment", goalID, messageID)
        return new Request(this, 'DELETE', 'comments/{0}'.f(messageID))
    }

    static bulkUpdate(data: {
        goalUpdates?: any
    }) {

        // "goalUpdates": {
        //     "fv8wo3": {"sortPosition": 1},
        //     "ZjkS96": {"sortPosition": 5}
        // }

        const params:any = {}
        if (data.goalUpdates) params.goalUpdates = data.goalUpdates

        return new Request(this, 'POST', 'bulk/goals/update', params)
    }
}
